import * as React from "react";
import * as Yup from "yup";
import { ChartSignatureHistoryApi, ChartSignaturesHistoryDto } from "../../../../api";
import { useTl, useApiService, useSaveApi } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { SmallFormGenerator, FGSRSHDateMaskInput } from "../../../../components";

export interface IPersonBreederChartSavePanelProps {
  onSaved: () => void;
  personId: number;
}

export const PersonBreederChartSavePanel: React.FunctionComponent<IPersonBreederChartSavePanelProps> = ({
  onSaved,
  personId,
}) => {
  const { t } = useTl();
  const api = useApiService(ChartSignatureHistoryApi);

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      dateFrom: Yup.date()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("date-from", t(ETLCodes.MustBeGreaterThanDateTo), async function (value) {
          return value < this.parent.dateTo;
        }),
      dateTo: Yup.date()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("date-to", t(ETLCodes.MustBeGreaterThanDateFrom), async function (value) {
          return value > this.parent.dateFrom;
        }),
    });
  }, [t]);
  const { saving, saveItem } = useSaveApi<ChartSignaturesHistoryDto>(
    React.useMemo(
      () => ({
        saveApiFn: (data) => api.saveChartHistorySignature(data),
        onSaveFn: () => onSaved(),
      }),
      [api, onSaved]
    )
  );
  const initialData = React.useMemo(
    () =>
      new ChartSignaturesHistoryDto({
        personId: personId,
        dateFrom: new Date(new Date().getFullYear(), 0, 1),
        dateTo: new Date(new Date().getFullYear(), 11, 1),
      }),
    [personId]
  );

  return (
    <SmallFormGenerator
      onSubmit={saveItem}
      initialValues={initialData}
      editMode={true}
      validationSchema={FormSchema}
      saving={saving}
      dirtyCheckSaveButton={false}
    >
      <FGSRSHDateMaskInput name="dateFrom" label={t(ETLCodes.DateFrom)} />
      <FGSRSHDateMaskInput name="dateTo" label={t(ETLCodes.DateTo)} />
    </SmallFormGenerator>
  );
};
